/**
 * Priority order for tooltips - lower index = higher priority.
 * Only one tooltip can show at a time, and higher priority tooltips take precedence.
 */
export const TOOLTIP_PRIORITY = [
  "tooltip_first_chat", // Highest priority - first interaction
  "tooltip_worktree", // Worktree explanation
  "tooltip_git_integration", // Git integration (shows before new session button)
  "tooltip_git_sidebar", // Git sidebar
  "tooltip_new_session_button", // New session guidance (shows after git integration dismissed)
  "tooltip_machine_disconnected", // Machine disconnected - lower priority
] as const;

export type TooltipKey = (typeof TOOLTIP_PRIORITY)[number];

export interface TooltipManagerContextValue {
  /** The currently active tooltip key, or null if none */
  activeTooltip: TooltipKey | null;
  /** Register a tooltip that wants to show */
  registerTooltip: (key: TooltipKey) => void;
  /** Unregister a tooltip (when dismissed or conditions no longer met) */
  unregisterTooltip: (key: TooltipKey) => void;
  /** Check if a specific tooltip should be visible */
  isTooltipVisible: (key: TooltipKey) => boolean;
}
